var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12.8091C4 8.39388 7.584 4.80908 12 4.80908C16.424 4.80908 20 8.39388 20 12.8091C20 17.2259 16.424 20.8091 12 20.8091C7.584 20.8091 4 17.2259 4 12.8091ZM14.9505 15.7539C15.2832 15.4224 15.2832 14.8847 14.9505 14.5523L13.2086 12.8119L14.9505 11.0705C15.2832 10.7391 15.2832 10.1916 14.9505 9.85914C14.6177 9.52573 14.0795 9.52573 13.737 9.85914L12.0049 11.5985L10.263 9.85914C9.92049 9.52573 9.38226 9.52573 9.04954 9.85914C8.71682 10.1916 8.71682 10.7391 9.04954 11.0705L10.7914 12.8119L9.04954 14.5425C8.71682 14.8847 8.71682 15.4224 9.04954 15.7539C9.2159 15.9201 9.44098 16.0091 9.65627 16.0091C9.88135 16.0091 10.0966 15.9201 10.263 15.7539L12.0049 14.0243L13.7468 15.7539C13.9131 15.9309 14.1284 16.0091 14.3437 16.0091C14.5688 16.0091 14.7841 15.9201 14.9505 15.7539Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.fdfaf85612165e0dd8b214106936fcea.svg";
export { ForwardRef as ReactComponent };